import { twMerge } from "@/utils/twMerge";

import { SidebarToolbar } from "./SidebarToolbar";

import type { ComponentProps } from "react";

/**
 * A row of panel controls: a toolbar of its own in an expanded sidebar, a named group in a collapsed
 * one, where the whole column is a single toolbar and a nested one would fight it for arrow keys.
 */
export function PanelToolbar({
  label,
  isCollapsed,
  className,
  children,
  ...props
}: ComponentProps<"div"> & { label: string; isCollapsed?: boolean }) {
  if (isCollapsed) {
    return (
      <div
        role="group"
        aria-label={label}
        className={twMerge("flex flex-col", className)}
        {...props}
      >
        {children}
      </div>
    );
  }

  return (
    <SidebarToolbar label={label} className={className} {...props}>
      {children}
    </SidebarToolbar>
  );
}
